import React from 'react';
import ReactMarkdownWithHtml from 'react-markdown/with-html';
import './MarkdownStyle.css';

const Markdown = props => {
    const { def } = props;
    return <p style={{ whiteSpace: 'pre-wrap' }} data-input={'markdown_de'} className='markdown_de'>
        <ReactMarkdownWithHtml allowDangerousHtml>
            {def.markdown}
        </ReactMarkdownWithHtml>
    </p>
}

export default Markdown;
